module.exports = __webpack_public_path__ + "static/media/5 1 Leseforstaelse Intro.a3c48357.mp3";